import script from "./PlanCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanCard.vue?vue&type=script&setup=true&lang=ts"

import "./PlanCard.vue?vue&type=style&index=0&id=83fe9762&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83fe9762"]])

export default __exports__